import axiosServices, { buildQueryParams, PaginationAndFiltersParams } from 'utils/axios';
import { GenericTableDataFileDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';
import ListWithTotal from 'common/dto-types/list-with-total-dto';

export const getFiles = async (params: PaginationAndFiltersParams): Promise<ListWithTotal<GenericTableDataFileDto>> => {
    const res = await axiosServices.get<ListWithTotal<GenericTableDataFileDto>>(
        `${InsideFifaBackOfficeEndpoints.GenericTables.Files}${buildQueryParams(params)}`,
    );
    return res.data;
};
